var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center py-8"},[_c('v-progress-circular',{staticClass:"ma-4",attrs:{"indeterminate":"","color":"#7070a0"}}),_c('p',[_vm._t("default",[_vm._v("Please wait…")])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }